export default __webpack_public_path__ + "static/media/calendar-delete.188316df.svg";